import React from 'react';
import PropTypes from 'prop-types';
import './Blur.css';

const Blur = (props) => {
  const { colors } = props;
  const bg = { background: `${colors[0]}` };
  const arrayBlur = Array(20).fill(<span></span>);

  return (
    <div className="blur-block" style={bg}>
      {arrayBlur.map((item, index) => (
        <React.Fragment key={index.toString()}>{item}</React.Fragment>
      ))}
    </div>
  );
};

Blur.propTypes = {
  colors: PropTypes.array,
};

export default Blur;
